import service from './service';
import { SORT_ORDER } from '@/resources/Constants'

const PAGE_SIZE = 10;
const DEFAULT_SORT_BY = 'id';
const DEFAULT_SORT_ORDER = SORT_ORDER.ASC;

const state = {
  aes_envelopestats: null,
  pageInfo: {
    totalItems: 0,
    totalPages: 0,
    pageNumber: 1
  },
  sort: DEFAULT_SORT_BY,
  sortOrder: DEFAULT_SORT_ORDER,
  searchQuery: null
};

const getters = {};

const actions = {
  async getAll(
    { commit, state },
    pageNumber = state.pageInfo.pageNumber,
    sort = state.sort,
    sortOrder = state.sortOrder,
    searchQuery = state.searchQuery
  ) {
    const results = await service.getByParams(
      pageNumber,
      PAGE_SIZE,
      sort,
      sortOrder,
      searchQuery
    );
    commit('setaes_envelopestat', results);
  },
  async get(
    { commit, state },
    pageNumber = state.pageInfo.pageNumber,
    sort = state.sort,
    sortOrder = state.sortOrder,
    searchQuery = state.searchQuery
  ) {
    const results = await service.getByParams(
      pageNumber,
      PAGE_SIZE,
      sort,
      sortOrder,
      searchQuery
    );
    commit('setaes_envelopestat', results);
  },
  async sortGrid({ commit, state }, sort, sortOrder = null) {
    if (sort == state.sort && sortOrder == state.sortOrder) {
      return;
    }
    if (!sortOrder) {
      sortOrder =
        state.sortOrder == SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
    }
    if (sort != state.sort) {
      sortOrder = DEFAULT_SORT_ORDER;
    }
    const results = await service.getByParams(
      1,
      PAGE_SIZE,
      sort,
      sortOrder,
      state.searchQuery
    );
    commit('setaes_envelopestat', { ...results, sort, sortOrder });
  },
  async getPage({ commit, state }, pageNumber) {
    if (pageNumber == state.pageInfo.pageNumber) {
      return;
    }
    const results = await service.getByParams(
      pageNumber,
      PAGE_SIZE,
      state.sort,
      state.sortOrder,
      state.searchQuery
    );
    commit('setaes_envelopestat', results);
  },
  async search({ commit, state }, searchQuery) {
    const results = await service.getByParams(
      1,
      PAGE_SIZE,
      state.sort,
      state.sortOrder,
      searchQuery
    );
    commit('setaes_envelopestat', { ...results, searchQuery });
  }
};

const mutations = {
  setaes_envelopestat(state, payload) {
    state.aes_envelopestats = payload.items;
    state.pageInfo = payload.pageInfo;
    ['sort', 'sortOrder', 'searchQuery'].forEach(key => {
      if (payload.hasOwnProperty(key)) {
        state[key] = payload[key];
      }
    });
  }
};

const aes_envelopestats = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default aes_envelopestats;
